import React from "react";

export const ImportantDate = ( props ) => {
    const {text} = props;
    return <span style={{fontWeight: 'bold', color: '#fe8400'}}>{text}</span>
};